import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { LocalizationService } from '@capital-access/common/localization';
import { FireflyModalService, ModalRef } from '@capital-access/firefly/components';
import { CompositeId, RecordSource } from '@capital-access/profiles/common';
import { PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE } from '../../models/constants';
import { RecordSourceExplanationModalComponent } from '../record-source-explanation-modal/record-source-explanation-modal.component';

@Component({
  selector: 'ca-record-source',
  templateUrl: 'record-source.component.html',
  standalone: false
})
export class RecordSourceComponent {
  private modal!: ModalRef<unknown> | null;
  L10N = PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE;
  source: RecordSource = RecordSource.PrCrm;

  @Input() dataAutomationId?: string;

  @Input() set compositeId(value: CompositeId) {
    this.source = this.getSourceValue(value);
  }

  getSourceValue(value: CompositeId) {
    if (value.hasPrId && !value.hasCrmId) {
      return RecordSource.Pr;
    }

    if (!value.hasPrId && value.hasCrmId) {
      return RecordSource.Crm;
    }

    return RecordSource.PrCrm;
  }

  onOpenExplanationModal() {
    this.localizationService
      .getLocalization(this.L10N)
      .pipe(take(1))
      .subscribe(
        ({
          explanationModalTitle,
          snpResearch,
          crm,
          snpCrm,
          snpResearchExplanation,
          snpCrmExplanation,
          crmExplanation
        }) => {
          this.modal = this.modalService.open({
            component: RecordSourceExplanationModalComponent,
            title: explanationModalTitle,
            context: {
              snpResearch,
              crm,
              snpCrm,
              snpResearchExplanation,
              snpCrmExplanation,
              crmExplanation
            },
            hideDefaultFooter: true,
            mobile: false
          });

          this.modal.result.finally(() => {
            this.modal = null;
          });
        }
      );
  }

  constructor(
    private store: Store,
    private modalService: FireflyModalService,
    private localizationService: LocalizationService
  ) {}
}
